import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Outlet, Navigate } from 'react-router-dom'
import PropTypes from 'prop-types'
// import { profileRequest } from '../../service/actions/userActions'
import { getProfile } from '../../service/actions/profileActions'

const PrivateRoute = ({ getProfileAction }) => {
  useEffect(() => {
    // getProfileAction()
  }, [])

  // useEffect(() => {
  //   if (notAccessed) {
  //     localStorage.removeItem('currentUser')
  //     window.location.reload()
  //   }
  // }, [notAccessed])

  return localStorage.getItem('oopToken') ? (
    // true
    <Outlet />
  ) : (
    <Navigate to="/login" />
  )
}
PrivateRoute.propTypes = {
  // getProfile: PropTypes.func,
  notAccessed: PropTypes.bool,
}
const mapStateToProps = (state) => ({
  notAccessed: state.userReducer.error,
})

const mapDispatchToProps = (dispatch) => ({
  getProfileAction: () => dispatch(getProfile()),
})

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute)
